import { ProviderBuyOrderComponent } from "./provider-buy-order/provider-buy-order.component";
import { ProviderPricingComponent } from "./provider-pricing/provider-pricing.component";

export const providerRoutes = [
  {
    path: 'pricing',
    component: ProviderPricingComponent,
  },
  {
    path: 'buy-order',
    component: ProviderBuyOrderComponent,
  }
];
